import React, { Component } from "react";
import { Container, Jumbotron } from "reactstrap";
import { Animated } from "react-animated-css";
import Footer from "./Footer";
import Navbar from "./Navbar";

class Catering extends Component {
  render() {
    return (
      <div>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Navbar />
        </Animated>
        <Container>
        <div class="b b-- b--fw">
            <div class="b-c">
              <div class="sh ">
                <h2 class="sh-title">Catering Menu</h2>
              </div>
            </div>
          </div>
          <Animated
            animationInDelay={100}
            animationIn="bounceInLeft"
            animationOut="bounceInRight"
            isVisible
          >
            <Jumbotron>
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./17.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div class="cd-c">
                  <div class="cd-t">Whole New York Cheesecase</div>
                  <div class="cd-st t--upper t--subtitle">$45</div>
                </div>
              </div>

              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./16.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div class="cd-c">
                  <div class="cd-t">Whole Banana Cheesecake</div>
                  <div class="cd-st t--upper t--subtitle">$60</div>
                </div>
              </div>
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./23.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div class="cd-c">
                  <div class="cd-t">Speciality (Alcohol) Letter Cakes</div>
                  <div class="cd-st t--upper t--subtitle">$50 for each letter</div>
                </div>
              </div>
              <div
                style={{ display: "inline-block" }}
                className="cd m-t500 g--4 g--4--sl"
              >
                <div
                  className="cd-ic"
                  style={{
                    backgroundImage: "url(./24.jpg)",
                    paddingBottom: "95%",
                  }}
                />
                <div class="cd-c">
                  <div class="cd-t">Churro Cheesecake Cups</div>
                  <div class="cd-st t--upper t--subtitle">$36 for a dozen</div>
                </div>
              </div>
            </Jumbotron>
          </Animated>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default Catering;
